import moment from 'moment';

export const getPostPath = (slug) => {
  return `/issue/${slug}`;
};

export const getIssuePath = (slug) => {
  return `/${slug}`;
};

export const getGroupedIssuePosts = (posts) => {
  const spotlightPosts = [];
  const restPosts = [];
  const conclusionPosts = [];

  for (const post of posts) {
    if (Number(post.tghpwipArticleSpotlighted) === 1) {
      spotlightPosts.push(post);
    } else if (Number(post.tghpwipArticleIsConclusion) === 1) {
      conclusionPosts.push(post);
    } else {
      restPosts.push(post);
    }
  }

  return [spotlightPosts, restPosts, conclusionPosts];
};

export const getRelatedArticlesByCategory = (categorySlug, allArticles) => {
  return allArticles
    .filter((article) => {
      const categories = article.categories.nodes;
      return categories.find((category) => category.slug === categorySlug);
    })
    .slice(0, 3);
};

export const getRelatedArticlesByIssue = (issueSlug, allArticles) => {
  return allArticles
    .filter((article) => {
      const issues = article.tghpTaxonomyIssues.nodes;
      return issues.find((issue) => issue.slug === issueSlug);
    })
    .slice(0, 3);
};

export const getRelatedArticlesManualSelect = (selectedPosts, allArticles) => {
  if (!selectedPosts || !allArticles) {
    return [];
  }

  const posts = selectedPosts.map((postId, idx) => {
    return {
      postId: Number(postId),
      order: idx + 1,
    };
  });

  return allArticles
    .filter((article) => posts.find((post) => post.postId === article.databaseId))
    .map((article) => {
      const item = posts.find((post) => post.postId === article.databaseId);
      return {
        ...article,
        order: item.order,
      };
    })
    .sort((postA, postB) => postA.order - postB.order);
};

export const replaceImageBlockFigcaptionStrings = (content) => {
  const withBreak = /<figcaption>(.*?)<br ?\/?>(.+)<\/figcaption>/gi;
  const captionHasBreak = withBreak.test(content);

  const withOutBreak = /<figcaption>(?!.*<br.*?)[\s\S]*?<\/figcaption>/gi;
  const captionNoBreak = withOutBreak.test(content);

  if (captionNoBreak || captionHasBreak) {
    content = content
      .replace(withOutBreak, (wholeMatch) => {
        const figcaptionTagsRemoved = wholeMatch
          .replace('<figcaption>', '')
          .replace('</figcaption>', '');
        return `
          <figcaption>
            <div class='wp-block-image__caption-grid wp-block-image__caption-grid--col-1'>
              <div class='wp-block-image__caption-grid-col'>
                <div class='wp-block-image__caption-grid-col-title'>Image</div>
                <div class='wp-block-image__caption-grid-col-caption'>
                  ${figcaptionTagsRemoved}
                </div>
              </div>
            </div>
          </figcaption>
        `;
      })
      .replace(withBreak, (wholeMatch, photographer, caption) => {
        return `
          <figcaption>
            <div class='wp-block-image__caption-grid'>
              <div class='wp-block-image__caption-grid-col'>
                ${caption}
              </div>
              <div class='wp-block-image__caption-grid-col'>
                <div class='wp-block-image__caption-grid-col-title'>Image</div>
                <div class='wp-block-image__caption-grid-col-caption'>
                  ${photographer}
                </div>
              </div>
            </div>
          </figcaption>
        `;
      });
  }

  return content;
};

export const getValidCategoryNames = (categories) => {
  return categories.filter((item) => item.slug !== 'uncategorized').map((item) => item.name);
};

export const getFormattedDate = (date) => {
  return moment(date).format('Mo MMMM YYYY');
};

export const getFormattedDuration = (secs) => {
  return moment.utc(secs * 1000).format('HH:mm:ss');
};

export const getVimeoVideoJson = async (videoCode) => {
  return await fetch(
    `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoCode}&autoplay=1`,
  ).then((response) => response.json());
};

export const convertToTimeString = (currentTime) => {
  const second = parseInt(currentTime, 10);
  const hour = Math.floor(second / 3600);
  const minute = Math.floor((second - hour * 3600) / 60);
  const seconds = second - hour * 3600 - minute * 60;

  const hourString = `${hour.toString().padStart(2, '0')}`;
  const minuteString = `${minute.toString().padStart(2, '0')}`;
  const secondString = `${seconds.toString().padStart(2, '0')}`;
  return `${hour > 0 ? `${hourString}:` : ''}${minuteString}:${secondString}`;
};

export const getPageObj = (pageId, allPages) => {
  return allPages.find((page) => page.databaseId === Number(pageId));
};

export const convertNumberToRoman = (number) => {
  let numeral = '';
  let numeralCodes = [
    ['', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'], // Ones
    ['', 'X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC'], // Tens
    ['', 'C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM'], // Hundreds
  ];
  let digits = number.toString().split('').reverse();

  for (let i = 0; i < digits.length; i++) {
    numeral = numeralCodes[i][parseInt(digits[i])] + numeral;
  }

  return numeral;
};

export const getDataWrapperHeight = (e) => {
  if(void 0 !== e.data["datawrapper-height"]) {
    let t = document.querySelectorAll("iframe");
    for(let a in e.data["datawrapper-height"]) {
      for(let r= 0; r < t.length; r++){
        if(t[r].contentWindow === e.source) {
          t[r].style.height = e.data["datawrapper-height"][a]+"px";
          t[r].parentElement.classList.add('data-wrapper--loaded');
        }
      }
    }
  }
};
